// extracted by mini-css-extract-plugin
module.exports = {"Card":"TotalCard_Card__2qWBR","PriceCard":"TotalCard_PriceCard__3ifTh"};